import { Link } from "react-router-dom";
import { Phone, MessageCircle, FileText } from "lucide-react";
import { useSiteContent } from "@/context/ContentContext";

export function MobileContactBar() {
  const { contact } = useSiteContent();
  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-3 border-t border-[#E3E8EF] bg-white shadow-[0_-4px_20px_rgba(14,34,56,0.08)]" data-testid="mobile-contact-bar">
      <a href={`tel:${contact.phone}`} className="flex flex-col items-center gap-1 py-2.5 text-ink active:bg-canvas transition-colors" data-testid="mobile-bar-call">
        <Phone className="w-5 h-5" /><span className="text-[11px] font-semibold">Call</span>
      </a>
      <a href={`https://wa.me/${contact.whatsapp}`} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center gap-1 py-2.5 text-ink border-x border-[#E3E8EF] active:bg-canvas transition-colors" data-testid="mobile-bar-whatsapp">
        <MessageCircle className="w-5 h-5" /><span className="text-[11px] font-semibold">WhatsApp</span>
      </a>
      <Link to="/request-a-quote" className="flex flex-col items-center gap-1 py-2.5 bg-amber text-maintext active:bg-amber-hover transition-colors" data-testid="mobile-bar-quote">
        <FileText className="w-5 h-5" /><span className="text-[11px] font-semibold">Quote</span>
      </Link>
    </div>
  );
}
